import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Card, CardBody, Spinner, FormGroup, Input,
  Badge, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import Select from '../../../components/Template/Input/Select'
import DataTable from '../../../components/Template/Table/DataTable'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { getTiSolicitations, postTiSolicitation } from '../../../store/ducks/patrimony'

const subjects = [
  {
    label: 'Computador',
    value: 'Computador',
  },
  {
    label: 'Licenciamento ou Permissões',
    value: 'Licenciamento ou Permissões',
  },
  {
    label: 'Rede',
    value: 'Rede',
  },
  {
    label: 'Software',
    value: 'Software',
  },
  {
    label: 'Telefonia',
    value: 'Telefonia',
  },
]

const priorities = [
  {
    label: 'Prioridade 1 - Urgentíssimo',
    value: 'Prioridade 1 - Urgentíssimo',
  },
  {
    label: 'Prioridade 2 - Urgente',
    value: 'Prioridade 2 - Urgente',
  },
  {
    label: 'Prioridade 3 - Importante',
    value: 'Prioridade 3 - Importante',
  },
  {
    label: 'Prioridade 4 - Necessário',
    value: 'Prioridade 4 - Necessário',
  },
  {
    label: 'Prioridade 5 - Sugestão',
    value: 'Prioridade 5 - Sugestão',
  },
]

class TiSolicitations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addSolicitationModalIsOpen: false,
      subject: '',
      subjectInputError: '',
      patrimony: '',
      patrimonyInputError: '',
      priority: '',
      priorityInputError: '',
      description: '',
      descriptionInputError: '',
      endDate: '',
      endDateInputError: '',
    }
  }

  componentDidMount() {
    const { getTiSolicitations } = this.props

    getTiSolicitations()
  }

  componentDidUpdate(prevProps) {
    const { getTiSolicitations } = this.props
    const { postTiSolicitationIsLoading, postTiSolicitationSuccess } = this.props.patrimony

    if (
      prevProps.patrimony.postTiSolicitationIsLoading !== postTiSolicitationIsLoading
      && !postTiSolicitationIsLoading
      && postTiSolicitationSuccess
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ addSolicitationModalIsOpen: false })
      getTiSolicitations()
    }

    return true
  }

  formatStatus = status => {
    switch (status) {
      case 'Recebido' || 'Chamado aberto' || 'Em atendimento':
        return <Badge className="badge-soft-info mr-1">{status}</Badge>
      case 'Solucionado':
        return <Badge className="badge-soft-success mr-1">{status}</Badge>
      case 'Sem solução':
        return <Badge className="badge-soft-danger mr-1">{status}</Badge>
      default:
        return null
    }
  }

  toggleModal = () => {
    const { postTiSolicitationIsLoading } = this.props.patrimony

    if (postTiSolicitationIsLoading) return null

    this.setState(prevState => ({
      addSolicitationModalIsOpen: !prevState.addSolicitationModalIsOpen,
    }))

    return null
  }

  handlePostTiSolicitationSubmit = () => {
    const { postTiSolicitation } = this.props
    const { subject, patrimony, priority, description, endDate } = this.state

    if (!subject) this.setState({ subjectInputError: 'Campo obrigatório.' })
    if (!patrimony) this.setState({ patrimonyInputError: 'Campo obrigatório.' })
    if (!priority) this.setState({ priorityInputError: 'Campo obrigatório.' })
    if (!description) this.setState({ descriptionInputError: 'Campo obrigatório.' })
    if (!endDate) this.setState({ endDateInputError: 'Campo obrigatório.' })

    if (subject && patrimony && priority && description) {
      postTiSolicitation({
        subject,
        patrimony,
        priority,
        description,
        endDate,
      })
    }

    return null
  }

  render() {
    const {
      getTiSolicitationsIsLoading, tiSolicitations,
      postTiSolicitationIsLoading,
    } = this.props.patrimony

    const {
      addSolicitationModalIsOpen, subjectInputError,
      patrimony, patrimonyInputError, priorityInputError,
      description, descriptionInputError, endDate, endDateInputError,
    } = this.state

    return (
      <div className="page-content">
        <Modal
          centered
          isOpen={addSolicitationModalIsOpen}
          toggle={() => this.toggleModal()}
        >
          <ModalHeader toggle={() => this.toggleModal()}>
            Novo chamado de TI
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Assunto</Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={false}
                isSearchable={false}
                placeholder="Assunto"
                options={subjects || []}
                onChange={subject => {
                  this.setState({
                    subject,
                    subjectInputError: '',
                  })
                }}
              />
              {subjectInputError && <span style={{ color: 'red' }}>{subjectInputError}</span>}
            </FormGroup>
            <FormGroup>
              <Label>Prioridade</Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={false}
                isSearchable={false}
                placeholder="Prioridade"
                options={priorities || []}
                onChange={priority => {
                  this.setState({
                    priority,
                    priorityInputError: '',
                  })
                }}
              />
              {priorityInputError && <span style={{ color: 'red' }}>{priorityInputError}</span>}
            </FormGroup>
            <FormGroup>
              <Label>Patrimônio</Label>
              <Input
                className="form-control"
                type="text"
                value={patrimony}
                onChange={e => this.setState({
                  patrimony: e.target.value,
                  patrimonyInputError: '',
                })}
              />
              {
                patrimonyInputError
                && (
                  <span style={{ color: 'red' }}>
                    {patrimonyInputError}
                  </span>
                )
              }
            </FormGroup>
            <FormGroup>
              <Label>Prazo de atendimento desejado</Label>
              <DatePicker
                locale="pt-BR"
                className="form-control"
                selected={endDate}
                minDate={new Date()}
                dateFormat="dd/MM/yyyy"
                onChange={endDate => this.setState({
                  endDate,
                  endDateInputError: '',
                })}
              />
              {
                endDateInputError
                && (
                  <span style={{ color: 'red' }}>
                    {endDateInputError}
                  </span>
                )
              }
            </FormGroup>
            <FormGroup>
              <Label>Descrição</Label>
              <Input
                className="form-control"
                type="textarea"
                value={description}
                onChange={e => this.setState({
                  description: e.target.value,
                  descriptionInputError: '',
                })}
              />
              {
                descriptionInputError
                && (
                  <span style={{ color: 'red' }}>
                    {descriptionInputError}
                  </span>
                )
              }
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.toggleModal()}
              color="light"
              className="waves-effect"
              disabled={postTiSolicitationIsLoading}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => this.handlePostTiSolicitationSubmit()}
              disabled={postTiSolicitationIsLoading}
            >
              Enviar
              {postTiSolicitationIsLoading && (
                <Spinner size="sm" className="ml-2" />
              )}
            </Button>
          </ModalFooter>
        </Modal>

        <Container fluid>
          <Breadcrumbs
            title="Chamados de TI"
            breadcrumbItems={[]}
          />

          <Row>
            <Col>
              <h4>
                Lista
              </h4>
            </Col>

            <Col style={{ textAlign: 'right' }}>
              <Button
                color="primary"
                type="button"
                onClick={() => this.toggleModal()}
              >
                Novo chamado
              </Button>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Card>
                <CardBody>
                  {getTiSolicitationsIsLoading && (
                    <Row>
                      <Col className="d-flex align-items-center justify-content-center py-3">
                        <Spinner size="sm" />
                      </Col>
                    </Row>
                  )}

                  {!getTiSolicitationsIsLoading && tiSolicitations && (
                    <DataTable
                      data={{
                        columns: [
                          {
                            label: 'ID',
                            field: 'id',
                          },
                          {
                            label: 'Data de solicitação',
                            field: 'createDt',
                            sort: 'disabled',
                          },
                          {
                            label: 'Prazo desejado',
                            field: 'endDt',
                            sort: 'disabled',
                          },
                          {
                            label: 'Assunto',
                            field: 'subject',
                            sort: 'disabled',
                          },
                          {
                            label: 'Prioridade',
                            field: 'priority',
                            sort: 'disabled',
                          },
                          {
                            label: 'Patrimônio',
                            field: 'patrimony',
                            sort: 'disabled',
                          },
                          {
                            label: 'Descrição',
                            field: 'description',
                            sort: 'disabled',
                          },
                          {
                            label: 'Status',
                            field: 'status',
                            sort: 'disabled',
                          },
                        ],
                        rows: tiSolicitations.map(row => ({
                          id: Number(row.fields.id),
                          createDt: moment(row.fields.Created).format('DD/MM/YYYY'),
                          endDt: moment(row.fields.PrazodeAtendimentoDesejado).format('DD/MM/YYYY'),
                          subject: row.fields.TipodeDemanda,
                          priority: row.fields.Prioridade,
                          patrimony: row.fields.Title,
                          description: row.fields.DescrevasuaDemanda,
                          status: this.formatStatus(row.fields.Status),
                        })),
                      }}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ patrimony: state.patrimony })
const mapDispatchToProps = dispatch => bindActionCreators({
  getTiSolicitations,
  postTiSolicitation,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(TiSolicitations)
